import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '业务处理需求',
    type: 'BD_LOGIC',
}
